import api from './api'

export const featureAnnouncementService = {
  async getUnseen() {
    const { data } = await api.get('/feature-announcements/unseen')
    return data
  },

  async updateFrequency(frequency) {
    const { data } = await api.put('/users/me/preferences', {
      announcementFrequency: frequency
    })
    return data
  },

  async markAsRead(announcementIds) {
    const { data } = await api.post('/feature-announcements/mark-read', { announcementIds })
    return data
  },

  async list(params = {}) {
    const { data } = await api.get('/feature-announcements', { params })
    return data
  },

  // Admin methods
  async adminList(params = {}) {
    const { data } = await api.get('/feature-announcements/admin', { params })
    return data
  },

  async adminGet(id) {
    const { data } = await api.get(`/feature-announcements/admin/${id}`)
    return data
  },

  async adminCreate(payload) {
    const { data } = await api.post('/feature-announcements/admin', payload)
    return data
  },

  async adminUpdate(id, payload) {
    const { data } = await api.put(`/feature-announcements/admin/${id}`, payload)
    return data
  },

  async adminDelete(id) {
    const { data } = await api.delete(`/feature-announcements/admin/${id}`)
    return data
  },

  async adminPublish(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/publish`)
    return data
  },

  async adminUnpublish(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/unpublish`)
    return data
  },

  async adminArchive(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/archive`)
    return data
  },

  async adminUnarchive(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/unarchive`)
    return data
  },

  async adminToggleFeatured(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/toggle-featured`)
    return data
  },

  async adminSendEmail(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/send-email`)
    return data
  },

  async adminScheduleEmail(id) {
    const { data } = await api.post(`/feature-announcements/admin/${id}/schedule-email`)
    return data
  },

  async adminGetEmailQueue() {
    const { data } = await api.get('/feature-announcements/admin/email-queue')
    return data
  },

  async adminGenerateFromCommits(count = 20) {
    const { data } = await api.post('/feature-announcements/admin/generate-from-commits', { count })
    return data
  }
}

export default featureAnnouncementService
